import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root',
})
export class ApiUserOrgRolesService {
  orgRoleActionSubject = new Subject<any>();
  orgRoleActionID = new Subject<any>();
  editRole = new Subject<any>();
  filterProductsData = new Subject<any>();
  validationData = new Subject<any>();

  constructor(private apiBasic: ApiBasicService) { }

  /**
   *
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {
    return this.apiBasic.getList(params, 'uroles_in_orgs');
  }

  /**
   *
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {
    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   *
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {
    return this.apiBasic.edit('uroles_in_orgs', id);
  }

  /**
   *
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {
    return this.apiBasic.create('uroles_in_orgs', params);
  }

  /**
   *
   * @param params any
   * @returns Observable<Res>
   */
  update(params: any): Observable<Res> {
    return this.apiBasic.update('uroles_in_orgs', params);
  }

  /**
   *
   * @param params any
   * @returns Observable<Res>
   */
  updateUserRole(params: any): Observable<Res> {
    return this.apiBasic.update('position_and_urole', params);
  }

  /**
   *
   */
  delete(params: any): Observable<Res> {
    return this.apiBasic.delete('uroles_in_orgs/delete', params);
  }

  /**
   *
   * @param params
   * @returns
   */
  deleteRole(params: any): Observable<Res> {
    return this.apiBasic.deleteRole('uroles_in_orgs/delete', params);
  }

  /**
   *
   * @param params
   * @returns
   */
  roleLockAndUnlockControl(params: any): Observable<Res> {
    return this.apiBasic.roleControl('uroles_in_orgs/delete', params);
  }

  /**
   * @param data
   */
  setActinoData(data: any): void {
    this.orgRoleActionSubject.next(data);
  }

  /* Method to listen for change
   * @returns Observable<any>
   */
  listenerActionData(): Observable<any> {
    return this.orgRoleActionSubject.asObservable();
  }

  /**
   * @param data
   */
  setRoleId(data: any): void {
    this.orgRoleActionID.next(data);
  }

  /* Method to listen for change
   * @returns Observable<any>
   */
  listenerRoleId(): Observable<any> {
    return this.orgRoleActionID.asObservable();
  }


  /**
   * @param data
   */
  setRoleEdit(data: any): void {
    this.editRole.next(data);
  }


  /**
   * 
   * @returns 
   */
  listenerRoleEdit(): Observable<any> {
    return this.editRole.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setFilterProductsData(data: any): void {
    this.filterProductsData.next(data);
  }


  /**
   * 
   * @returns 
   */
  listenerFilterProductsData(): Observable<any> {
    return this.filterProductsData.asObservable();
  }


  /**
   * 
   * @param data 
   */
  setFValidationData(data: any): void {

    this.validationData.next(data);
  }


  /**
   * 
   * @returns 
   */
  listenerValidationData(): Observable<any> {
    
    return this.validationData.asObservable();
  }

}
